import httpClient from './httpClient';
import { CreatorProjectPayload } from '@/types/api';

export interface CreatorProjectResponse {
	id: string;
	projectId?: string;
}

export interface CreatorProjectDetails extends CreatorProjectResponse, CreatorProjectPayload {
	uploadsMeta?: {
		id: string;
		label?: string;
		attachment: {
			id: string;
			path: string;
			name: string;
			mimetype: string;
			size: number;
		};
	}[];
	productType?: {
		id?: string;
		name?: string;
		slug?: string;
		description?: string | null;
		creatorDescription?: string | null;
		tags?: string[];
	} | null;
}

class CreatorProjectsApi {
	async create(payload: CreatorProjectPayload) {
		const response = await httpClient.post<CreatorProjectResponse>('creator/projects', payload);
		return response.data;
	}

	async update(id: string, payload: Partial<CreatorProjectPayload>) {
		const response = await httpClient.patch<CreatorProjectResponse>(`creator/projects/${id}`, payload);
		return response.data;
	}

	async submitQuote(
		id: string,
		contact: { name: string; surname: string; email: string; phone: string }
	) {
		const response = await httpClient.post<CreatorProjectResponse>(
			`creator/projects/${id}/submit-quote`,
			contact
		);
		return response.data;
	}

	async addToCart(id: string, payload?: { price?: number; grossPrice?: number }) {
		const response = await httpClient.post(`creator/projects/${id}/add-to-cart`, payload ?? {});
		return response.data;
	}

	async get(id: string) {
		const response = await httpClient.get<CreatorProjectDetails>(`creator/projects/${id}`);
		return response.data;
	}

	async getPreview(id: string) {
		const response = await httpClient.get<CreatorProjectDetails>(
			`creator/projects/preview/${id}`
		);
		return response.data;
	}

	async uploadFile(projectId: string, file: File, label?: string) {
		const formData = new FormData();
		formData.append('file', file);
		if (label) formData.append('label', label);

		const response = await httpClient.post(
			`creator/projects/${projectId}/uploads`,
			formData
		);
		return response.data as {
			id: string;
			attachment: {
				id: string;
				path: string;
				name: string;
				mimetype: string;
				size: number;
				width?: number;
				height?: number;
			};
		};
	}
}

export default new CreatorProjectsApi();
